
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import type { NextPage } from 'next';
import AuthContainer from '@components/auth/AuthContainer';
import { viewSignInOrSignUp } from '@lib/eventManager';
import { CloseHeader } from '@/components/commons';
import { STORAGE_KEY } from '@/common/values';

const AuthPage: NextPage = () => {
  const router = useRouter();
  const { backUrl } = router.query;

  useEffect(() => {
    viewSignInOrSignUp();
  }, []);

  return (
    <>
      <CloseHeader
        onClick={() => {
          localStorage.removeItem(STORAGE_KEY.REDIRECT_INFO);
          backUrl ? router.push(backUrl as string) : router.back();
        }}
      />
      <AuthContainer />
    </>
  );
};

export default AuthPage;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/auth/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  